import { makeStyles } from '@material-ui/core';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const swipeStyles = makeStyles(theme => ({
  enter: {
    opacity: 0,
    transform: 'translateX(100px)',
  },
  enterActive: {
    opacity: 1,
    transform: 'translateX(0px)',
    transition: '300ms ease-out',
  },
  exit: { opacity: 1, transform: 'translateX(0px)' },
  exitActive: { opacity: 0, transform: 'translateX(-100px)', transition: '300ms ease-out' },
}));

const SwipeTransition = ({ children, transitionKey, ...restProps }) => {
  const classes = swipeStyles();

  return (
    <TransitionGroup>
      <CSSTransition
        key={transitionKey}
        timeout={300}
        {...restProps}
        classNames={{
          enter: classes.enter,
          enterActive: classes.enterActive,
          exit: classes.exit,
          exitActive: classes.exitActive,
        }}>
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <div
            style={{
              position: 'absolute',
              width: 'max-content',
              // width: '100%',
              // height: '100%',
              // display: 'flex',
              // alignItems: 'center',
              // justifyContent: 'center',
            }}>
            {children}
          </div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default SwipeTransition;
